export default __webpack_public_path__ + "static/media/img1.c2db4f83.jpg";